import { render } from "./FormLottery.vue?vue&type=template&id=28abc2ee&scoped=true"
import script from "./FormLottery.vue?vue&type=script&lang=js"
export * from "./FormLottery.vue?vue&type=script&lang=js"

import "./FormLottery.vue?vue&type=style&index=0&id=28abc2ee&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28abc2ee"]])

export default __exports__